import React from 'react'
import { Link } from 'react-router-dom'
import type { ActiveCoupon } from '../../types/partnerDashboard'

interface CouponActiveCardProps {
  coupon: ActiveCoupon | null
  isAdmin: boolean
  accentColor: string
}

const formatDate = (iso: string) =>
  new Date(iso).toLocaleDateString('fr-CH', { day: '2-digit', month: '2-digit', year: 'numeric' })

/**
 * Affiche le coupon actif du partenaire ou un placeholder "Aucun coupon actif".
 */
const CouponActiveCard: React.FC<CouponActiveCardProps> = ({ coupon, isAdmin, accentColor }) => {
  return (
    <div
      data-testid="coupon-card"
      style={{
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '0.75rem',
        padding: '1.5rem',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '600', color: '#1e293b' }}>
          🎟️ Coupon actif
        </h3>
        {isAdmin && (
          <Link
            to="/partner/coupons"
            data-testid="manage-coupons-button"
            style={{
              padding: '0.4rem 0.75rem',
              background: accentColor,
              color: 'white',
              borderRadius: '0.375rem',
              textDecoration: 'none',
              fontSize: '0.85rem',
              fontWeight: '500',
            }}
          >
            Gérer les coupons
          </Link>
        )}
      </div>

      {coupon ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '1rem' }}>
          <div>
            <p style={{ margin: 0, color: '#64748b', fontSize: '0.8rem', textTransform: 'uppercase' }}>Code</p>
            <p
              data-testid="coupon-code"
              style={{
                margin: '0.25rem 0 0 0',
                fontWeight: '700',
                fontSize: '1.1rem',
                color: accentColor,
                fontFamily: 'monospace',
              }}
            >
              {coupon.code}
            </p>
          </div>
          <div>
            <p style={{ margin: 0, color: '#64748b', fontSize: '0.8rem', textTransform: 'uppercase' }}>Réduction membre</p>
            <p style={{ margin: '0.25rem 0 0 0', fontWeight: '600', color: '#1e293b' }}>{coupon.member_discount_pct}%</p>
          </div>
          <div>
            <p style={{ margin: 0, color: '#64748b', fontSize: '0.8rem', textTransform: 'uppercase' }}>Commission</p>
            <p style={{ margin: '0.25rem 0 0 0', fontWeight: '600', color: '#1e293b' }}>{coupon.partner_commission_pct}%</p>
          </div>
          <div>
            <p style={{ margin: 0, color: '#64748b', fontSize: '0.8rem', textTransform: 'uppercase' }}>Valide jusqu'au</p>
            <p style={{ margin: '0.25rem 0 0 0', fontWeight: '500', color: '#1e293b' }}>{formatDate(coupon.valid_until)}</p>
          </div>
          {coupon.max_usage_count != null && (
            <div>
              <p style={{ margin: 0, color: '#64748b', fontSize: '0.8rem', textTransform: 'uppercase' }}>Utilisations</p>
              <p style={{ margin: '0.25rem 0 0 0', fontWeight: '500', color: '#1e293b' }}>
                {coupon.current_usage_count} / {coupon.max_usage_count}
              </p>
            </div>
          )}
        </div>
      ) : (
        <p data-testid="no-active-coupon" style={{ margin: 0, color: '#94a3b8', fontStyle: 'italic' }}>
          Aucun avantage partenaire actif
        </p>
      )}
    </div>
  )
}

export default CouponActiveCard
